import type { GeneratedFile } from '@cli-types/core-engine/schema.js'

export function getGeneratedFilePaths(files: GeneratedFile[]): string[] {
  return files.map((file) => file.path)
}
